import { render, staticRenderFns } from "./EditMechanic.vue?vue&type=template&id=62357325&scoped=true"
import script from "./EditMechanic.vue?vue&type=script&lang=js"
export * from "./EditMechanic.vue?vue&type=script&lang=js"
import style0 from "./EditMechanic.vue?vue&type=style&index=0&id=62357325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62357325",
  null
  
)

export default component.exports